export default function ArticleTags({ tags }) {
  if (!tags?.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-10 pt-6 border-t border-gray-100">
      <span className="text-sm text-gray-400 mr-1">Tags</span>
      {tags.map((t, i) => (
        <span
          key={`${t}-${i}`}
          className="rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-600"
        >
          {t}
        </span>
      ))}
    </div>
  );
}
